import controller from './edit.controller';
import template from './edit.html';

function RouteConfig($stateProvider) {
	'ngInject';

	$stateProvider
		.state('app.private.tickets.edit', {
			controller,
			template,
			'url': '/edit?seatId&subLineId&busId&date',
			'controllerAs': 'vm',
			'resolve': {
				'Discounts': function(DiscountComponent) {
					'ngInject';

					return DiscountComponent.fetchDiscounts();
				},
				'Currencies': function(CurrencyComponent) {
					'ngInject';

					return CurrencyComponent.fetchCurrencies();
				},
				'Seat': function ($filter, $state, $stateParams, SubLineComponent, TicketComponent, Toast) {
					return TicketComponent.fetchSeat($stateParams.seatId)
						.then(function(res) {
							if (res.data && res.data.errors) {
								Toast.responseError(res.data.errors);
								$state.go('app.private.tickets.chooseSubLine');
							} else {
								let params;
								if ($stateParams.subLineId && $stateParams.busId && $stateParams.date) {
									params = {
										'subLineId': $stateParams.subLineId,
										'busId': $stateParams.busId,
										'date': $stateParams.date
									};
								} else {
									params = {
										'subLineId': res.sub_line_id,
										'busId': res.bus_id,
										'date': $filter('dateParser')(res.departs_at, 'YYYY-MM-DD')
									};
								}

								return SubLineComponent.fetchSubLine(params.subLineId, params.busId, params.date)
									.then(function(response) {
										if (response.data && response.data.errors) {
											Toast.responseError(response.data.errors);
											$state.go('app.private.tickets.chooseSubLine');
										} else {
											res.sub_line = response;

											return res;
										}
									});
							}
						});
				}
			}
		});
}

export default RouteConfig;



/** WEBPACK FOOTER **
 ** ./client/private/tickets/edit/edit.route.js
 **/